import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _construct from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/construct.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _objectSpread from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _createForOfIteratorHelper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { ThreadID as e } from "@textile/threads-id";
var n = function e(n, r, i) {
    if (Number.MAX_SAFE_INTEGER && n > Number.MAX_SAFE_INTEGER) throw e.bytes = 0, new RangeError("Could not encode varint");
    r = r || [];
    var s = i = i || 0;
    for (; n >= t;) r[i++] = 255 & n | 128, n /= 128;
    for (; -128 & n;) r[i++] = 255 & n | 128, n >>>= 7;
    return r[i] = 0 | n, e.bytes = i - s + 1, r;
  },
  t = Math.pow(2, 31);
var r = function e(n, t) {
  var r,
    i = 0,
    s = 0,
    o = t = t || 0,
    a = n.length;
  do {
    if (o >= a || s > 49) throw e.bytes = 0, new RangeError("Could not decode varint");
    r = n[o++], i += s < 28 ? (127 & r) << s : (127 & r) * Math.pow(2, s), s += 7;
  } while (r >= 128);
  return e.bytes = o - t, i;
};
var i = Math.pow(2, 7),
  s = Math.pow(2, 14),
  o = Math.pow(2, 21),
  a = Math.pow(2, 28),
  c = Math.pow(2, 35),
  l = Math.pow(2, 42),
  u = Math.pow(2, 49),
  k = Math.pow(2, 56),
  f = Math.pow(2, 63),
  b = {
    encode: n,
    decode: r,
    encodingLength: function encodingLength(e) {
      return e < i ? 1 : e < s ? 2 : e < o ? 3 : e < a ? 4 : e < c ? 5 : e < l ? 6 : e < u ? 7 : e < k ? 8 : e < f ? 9 : 10;
    }
  };
var d = function d(e) {
    return e && e.includeBoundaries ? "(?:(?<=\\s|^)(?=[a-fA-F\\d:])|(?<=[a-fA-F\\d:])(?=\\s|$))" : "";
  },
  p = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}",
  h = "[a-fA-F\\d]{1,4}",
  g = "\n(\n(?:".concat(h, ":){7}(?:").concat(h, "|:)|                                // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:").concat(h, ":){6}(?:").concat(p, "|:").concat(h, "|:)|                         // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:").concat(h, ":){5}(?::").concat(p, "|(:").concat(h, "){1,2}|:)|                 // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:").concat(h, ":){4}(?:(:").concat(h, "){0,1}:").concat(p, "|(:").concat(h, "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:").concat(h, ":){3}(?:(:").concat(h, "){0,2}:").concat(p, "|(:").concat(h, "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:").concat(h, ":){2}(?:(:").concat(h, "){0,3}:").concat(p, "|(:").concat(h, "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:").concat(h, ":){1}(?:(:").concat(h, "){0,4}:").concat(p, "|(:").concat(h, "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::((?::").concat(h, "){0,5}:").concat(p, "|(?::").concat(h, "){1,7}|:))           // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(%[0-9a-zA-Z]{1,})?                                           // %eth0            %1\n").replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(),
  y = new RegExp("(?:^".concat(p, "$)|(?:^").concat(g, "$)")),
  m = new RegExp("^".concat(p, "$")),
  w = new RegExp("^".concat(g, "$")),
  v = function v(e) {
    return e && e.exact ? y : new RegExp("(?:".concat(d(e)).concat(p).concat(d(e), ")|(?:").concat(d(e)).concat(g).concat(d(e), ")"), "g");
  };
v.v4 = function (e) {
  return e && e.exact ? m : new RegExp("".concat(d(e)).concat(p).concat(d(e)), "g");
}, v.v6 = function (e) {
  return e && e.exact ? w : new RegExp("".concat(d(e)).concat(g).concat(d(e)), "g");
};
var E = v;
var A = function A(e) {
  return E({
    exact: !0
  }).test(e);
};
A.v4 = function (e) {
  return E.v4({
    exact: !0
  }).test(e);
}, A.v6 = function (e) {
  return E.v6({
    exact: !0
  }).test(e);
}, A.version = function (e) {
  return A(e) ? A.v4(e) ? 4 : 6 : void 0;
};
var x = A;
var S = function S(e) {
  if (e.length >= 255) throw new TypeError("Alphabet too long");
  for (var n = new Uint8Array(256), t = 0; t < n.length; t++) n[t] = 255;
  for (var r = 0; r < e.length; r++) {
    var i = e.charAt(r),
      s = i.charCodeAt(0);
    if (255 !== n[s]) throw new TypeError(i + " is ambiguous");
    n[s] = r;
  }
  var o = e.length,
    a = e.charAt(0),
    c = Math.log(o) / Math.log(256),
    l = Math.log(256) / Math.log(o);
  function u(e) {
    if ("string" != typeof e) throw new TypeError("Expected String");
    if (0 === e.length) return new Uint8Array();
    var t = 0;
    if (" " !== e[t]) {
      for (var r = 0, i = 0; e[t] === a;) r++, t++;
      for (var s = (e.length - t) * c + 1 >>> 0, l = new Uint8Array(s); e[t];) {
        var u = n[e.charCodeAt(t)];
        if (255 === u) return;
        for (var k = 0, f = s - 1; (0 !== u || k < i) && -1 !== f; f--, k++) u += o * l[f] >>> 0, l[f] = u % 256 >>> 0, u = u / 256 >>> 0;
        if (0 !== u) throw new Error("Non-zero carry");
        i = k, t++;
      }
      if (" " !== e[t]) {
        for (var b = s - i; b !== s && 0 === l[b];) b++;
        for (var d = new Uint8Array(r + (s - b)), p = r; b !== s;) d[p++] = l[b++];
        return d;
      }
    }
  }
  return {
    encode: function encode(n) {
      if (n instanceof Uint8Array || (ArrayBuffer.isView(n) ? n = new Uint8Array(n.buffer, n.byteOffset, n.byteLength) : Array.isArray(n) && (n = Uint8Array.from(n))), !(n instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
      if (0 === n.length) return "";
      for (var t = 0, r = 0, i = 0, s = n.length; i !== s && 0 === n[i];) i++, t++;
      for (var c = (s - i) * l + 1 >>> 0, u = new Uint8Array(c); i !== s;) {
        for (var k = n[i], f = 0, b = c - 1; (0 !== k || f < r) && -1 !== b; b--, f++) k += 256 * u[b] >>> 0, u[b] = k % o >>> 0, k = k / o >>> 0;
        if (0 !== k) throw new Error("Non-zero carry");
        r = f, i++;
      }
      for (var d = c - r; d !== c && 0 === u[d];) d++;
      for (var p = a.repeat(t); d < c; ++d) p += e.charAt(u[d]);
      return p;
    },
    decodeUnsafe: u,
    decode: function decode(e) {
      var n = u(e);
      if (n) return n;
      throw new Error("Non-base" + o + " character");
    }
  };
};
function j(e) {
  var n = {
    exports: {}
  };
  return e(n, n.exports), n.exports;
}
var T = function T(e) {
    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
  },
  O = j(function (e) {
    "function" == typeof Object.create ? e.exports = function (e, n) {
      e.super_ = n, e.prototype = Object.create(n.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : e.exports = function (e, n) {
      e.super_ = n;
      var t = function t() {};
      t.prototype = n.prototype, e.prototype = new t(), e.prototype.constructor = e;
    };
  }),
  U = j(function (e, n) {
    var t = Object.getOwnPropertyDescriptors || function (e) {
        for (var n = Object.keys(e), t = {}, r = 0; r < n.length; r++) t[n[r]] = Object.getOwnPropertyDescriptor(e, n[r]);
        return t;
      },
      r = /%[sdj%]/g;
    n.format = function (e) {
      if (!h(e)) {
        for (var n = [], t = 0; t < arguments.length; t++) n.push(o(arguments[t]));
        return n.join(" ");
      }
      t = 1;
      for (var i = arguments, s = i.length, a = String(e).replace(r, function (e) {
          if ("%%" === e) return "%";
          if (t >= s) return e;
          switch (e) {
            case "%s":
              return String(i[t++]);
            case "%d":
              return Number(i[t++]);
            case "%j":
              try {
                return JSON.stringify(i[t++]);
              } catch (e) {
                return "[Circular]";
              }
            default:
              return e;
          }
        }), c = i[t]; t < s; c = i[++t]) d(c) || !m(c) ? a += " " + c : a += " " + o(c);
      return a;
    }, n.deprecate = function (e, t) {
      if ("undefined" != typeof process && !0 === process.noDeprecation) return e;
      if ("undefined" == typeof process) return function () {
        return n.deprecate(e, t).apply(this, arguments);
      };
      var r = !1;
      return function () {
        if (!r) {
          if (process.throwDeprecation) throw new Error(t);
          process.traceDeprecation ? console.trace(t) : console.error(t), r = !0;
        }
        return e.apply(this, arguments);
      };
    };
    var i,
      s = {};
    function o(e, t) {
      var r = {
        seen: [],
        stylize: c
      };
      return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), b(t) ? r.showHidden = t : t && n._extend(r, t), g(r.showHidden) && (r.showHidden = !1), g(r.depth) && (r.depth = 2), g(r.colors) && (r.colors = !1), g(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = a), l(r, e, r.depth);
    }
    function a(e, n) {
      var t = o.styles[n];
      return t ? "[" + o.colors[t][0] + "m" + e + "[" + o.colors[t][1] + "m" : e;
    }
    function c(e, n) {
      return e;
    }
    function l(e, t, r) {
      if (e.customInspect && t && E(t.inspect) && t.inspect !== n.inspect && (!t.constructor || t.constructor.prototype !== t)) {
        var i = t.inspect(r, e);
        return h(i) || (i = l(e, i, r)), i;
      }
      var s = function (e, n) {
        if (g(n)) return e.stylize("undefined", "undefined");
        if (h(n)) {
          var t = "'" + JSON.stringify(n).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return e.stylize(t, "string");
        }
        if (p(n)) return e.stylize("" + n, "number");
        if (b(n)) return e.stylize("" + n, "boolean");
        if (d(n)) return e.stylize("null", "null");
      }(e, t);
      if (s) return s;
      var o = Object.keys(t),
        a = function (e) {
          var n = {};
          return e.forEach(function (e, t) {
            n[e] = !0;
          }), n;
        }(o);
      if (e.showHidden && (o = Object.getOwnPropertyNames(t)), v(t) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return u(t);
      if (0 === o.length) {
        if (E(t)) {
          var c = t.name ? ": " + t.name : "";
          return e.stylize("[Function" + c + "]", "special");
        }
        if (y(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
        if (w(t)) return e.stylize(Date.prototype.toString.call(t), "date");
        if (v(t)) return u(t);
      }
      var m,
        A = "",
        x = !1,
        S = ["{", "}"];
      (f(t) && (x = !0, S = ["[", "]"]), E(t)) && (A = " [Function" + (t.name ? ": " + t.name : "") + "]");
      return y(t) && (A = " " + RegExp.prototype.toString.call(t)), w(t) && (A = " " + Date.prototype.toUTCString.call(t)), v(t) && (A = " " + u(t)), 0 !== o.length || x && 0 != t.length ? r < 0 ? y(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(t), m = x ? function (e, n, t, r, i) {
        for (var s = [], o = 0, a = n.length; o < a; ++o) U(n, String(o)) ? s.push(k(e, n, t, r, String(o), !0)) : s.push("");
        return i.forEach(function (i) {
          i.match(/^\d+$/) || s.push(k(e, n, t, r, i, !0));
        }), s;
      }(e, t, r, a, o) : o.map(function (n) {
        return k(e, t, r, a, n, x);
      }), e.seen.pop(), function (e, n, t) {
        if (e.reduce(function (e, n) {
          return n.indexOf("\n"), e + n.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0) > 60) return t[0] + ("" === n ? "" : n + "\n ") + " " + e.join(",\n  ") + " " + t[1];
        return t[0] + n + " " + e.join(", ") + " " + t[1];
      }(m, A, S)) : S[0] + A + S[1];
    }
    function u(e) {
      return "[" + Error.prototype.toString.call(e) + "]";
    }
    function k(e, n, t, r, i, s) {
      var o, a, c;
      if ((c = Object.getOwnPropertyDescriptor(n, i) || {
        value: n[i]
      }).get ? a = c.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : c.set && (a = e.stylize("[Setter]", "special")), U(r, i) || (o = "[" + i + "]"), a || (e.seen.indexOf(c.value) < 0 ? (a = d(t) ? l(e, c.value, null) : l(e, c.value, t - 1)).indexOf("\n") > -1 && (a = s ? a.split("\n").map(function (e) {
        return "  " + e;
      }).join("\n").substr(2) : "\n" + a.split("\n").map(function (e) {
        return "   " + e;
      }).join("\n")) : a = e.stylize("[Circular]", "special")), g(o)) {
        if (s && i.match(/^\d+$/)) return a;
        (o = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
      }
      return o + ": " + a;
    }
    function f(e) {
      return Array.isArray(e);
    }
    function b(e) {
      return "boolean" == typeof e;
    }
    function d(e) {
      return null === e;
    }
    function p(e) {
      return "number" == typeof e;
    }
    function h(e) {
      return "string" == typeof e;
    }
    function g(e) {
      return void 0 === e;
    }
    function y(e) {
      return m(e) && "[object RegExp]" === A(e);
    }
    function m(e) {
      return "object" == typeof e && null !== e;
    }
    function w(e) {
      return m(e) && "[object Date]" === A(e);
    }
    function v(e) {
      return m(e) && ("[object Error]" === A(e) || e instanceof Error);
    }
    function E(e) {
      return "function" == typeof e;
    }
    function A(e) {
      return Object.prototype.toString.call(e);
    }
    function x(e) {
      return e < 10 ? "0" + e.toString(10) : e.toString(10);
    }
    n.debuglog = function (e) {
      if (g(i) && (i = process.env.NODE_DEBUG || ""), e = e.toUpperCase(), !s[e]) if (new RegExp("\\b" + e + "\\b", "i").test(i)) {
        var t = process.pid;
        s[e] = function () {
          var r = n.format.apply(n, arguments);
          console.error("%s %d: %s", e, t, r);
        };
      } else s[e] = function () {};
      return s[e];
    }, n.inspect = o, o.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, o.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      regexp: "red"
    }, n.isArray = f, n.isBoolean = b, n.isNull = d, n.isNullOrUndefined = function (e) {
      return null == e;
    }, n.isNumber = p, n.isString = h, n.isSymbol = function (e) {
      return "symbol" == typeof e;
    }, n.isUndefined = g, n.isRegExp = y, n.isObject = m, n.isDate = w, n.isError = v, n.isFunction = E, n.isPrimitive = function (e) {
      return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
    }, n.isBuffer = T;
    var S = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    function j() {
      var e = new Date(),
        n = [x(e.getHours()), x(e.getMinutes()), x(e.getSeconds())].join(":");
      return [e.getDate(), S[e.getMonth()], n].join(" ");
    }
    function U(e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }
    n.log = function () {
      console.log("%s - %s", j(), n.format.apply(n, arguments));
    }, n.inherits = O, n._extend = function (e, n) {
      if (!n || !m(n)) return e;
      for (var t = Object.keys(n), r = t.length; r--;) e[t[r]] = n[t[r]];
      return e;
    };
    var $ = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;
    function C(e, n) {
      if (!e) {
        var t = new Error("Promise was rejected with a falsy value");
        t.reason = e, e = t;
      }
      return n(e);
    }
    n.promisify = function (e) {
      if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
      if ($ && e[$]) {
        var n;
        if ("function" != typeof (n = e[$])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(n, $, {
          value: n,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), n;
      }
      function n() {
        for (var n, t, r = new Promise(function (e, r) {
            n = e, t = r;
          }), i = [], s = 0; s < arguments.length; s++) i.push(arguments[s]);
        i.push(function (e, r) {
          e ? t(e) : n(r);
        });
        try {
          e.apply(this, i);
        } catch (e) {
          t(e);
        }
        return r;
      }
      return Object.setPrototypeOf(n, Object.getPrototypeOf(e)), $ && Object.defineProperty(n, $, {
        value: n,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(n, t(e));
    }, n.promisify.custom = $, n.callbackify = function (e) {
      if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
      function n() {
        for (var n = [], t = 0; t < arguments.length; t++) n.push(arguments[t]);
        var r = n.pop();
        if ("function" != typeof r) throw new TypeError("The last argument must be of type Function");
        var i = this,
          s = function s() {
            return r.apply(i, arguments);
          };
        e.apply(this, n).then(function (e) {
          process.nextTick(s, null, e);
        }, function (e) {
          process.nextTick(C, e, s);
        });
      }
      return Object.setPrototypeOf(n, Object.getPrototypeOf(e)), Object.defineProperties(n, t(e)), n;
    };
  }),
  $ = {
    TextEncoder: "undefined" != typeof TextEncoder ? TextEncoder : U.TextEncoder,
    TextDecoder: "undefined" != typeof TextDecoder ? TextDecoder : U.TextDecoder
  };
var C = $.TextEncoder,
  z = $.TextDecoder,
  I = new z(),
  D = new C();
var N = {
  decodeText: function decodeText(e) {
    return I.decode(e);
  },
  encodeText: function encodeText(e) {
    return D.encode(e);
  },
  concat: function concat(e, n) {
    var t = new Uint8Array(n);
    var r = 0;
    var _iterator = _createForOfIteratorHelper(e),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _n = _step.value;
        t.set(_n, r), r += _n.length;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return t;
  }
};
var M = N.encodeText;
var P = /*#__PURE__*/function () {
  function P(e, n, t, r) {
    _classCallCheck(this, P);
    this.name = e, this.code = n, this.codeBuf = M(this.code), this.alphabet = r, this.codec = t(r);
  }
  _createClass(P, [{
    key: "encode",
    value: function encode(e) {
      return this.codec.encode(e);
    }
  }, {
    key: "decode",
    value: function decode(e) {
      var _iterator2 = _createForOfIteratorHelper(e),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _n2 = _step2.value;
          if (this.alphabet && this.alphabet.indexOf(_n2) < 0) throw new Error("invalid character '".concat(_n2, "' in '").concat(e, "'"));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return this.codec.decode(e);
    }
  }]);
  return P;
}();
var B = {
  rfc4648: function rfc4648(e) {
    return function (n) {
      return {
        encode: function encode(t) {
          return function (e, n, t) {
            var r = "=" === n[n.length - 1],
              i = (1 << t) - 1;
            var s = "",
              o = 0,
              a = 0;
            for (var _r = 0; _r < e.length; ++_r) for (a = a << 8 | e[_r], o += 8; o > t;) o -= t, s += n[i & a >> o];
            if (o && (s += n[i & a << t - o]), r) for (; s.length * t & 7;) s += "=";
            return s;
          }(t, n, e);
        },
        decode: function decode(t) {
          return function (e, n, t) {
            var r = {};
            for (var _e2 = 0; _e2 < n.length; ++_e2) r[n[_e2]] = _e2;
            var i = e.length;
            for (; "=" === e[i - 1];) --i;
            var s = new Uint8Array(i * t / 8 | 0);
            var o = 0,
              a = 0,
              c = 0;
            for (var _n3 = 0; _n3 < i; ++_n3) {
              var _i = r[e[_n3]];
              if (void 0 === _i) throw new SyntaxError("Invalid character " + e[_n3]);
              a = a << t | _i, o += t, o >= 8 && (o -= 8, s[c++] = 255 & a >> o);
            }
            if (o >= t || 255 & a << 8 - o) throw new SyntaxError("Unexpected end of data");
            return s;
          }(t, n, e);
        }
      };
    };
  }
};
var R = B.rfc4648,
  V = N.decodeText,
  F = N.encodeText,
  _ = [["identity", "\0", function () {
    return {
      encode: V,
      decode: F
    };
  }, ""], ["base2", "0", R(1), "01"], ["base8", "7", R(3), "01234567"], ["base10", "9", S, "0123456789"], ["base16", "f", R(4), "0123456789abcdef"], ["base16upper", "F", R(4), "0123456789ABCDEF"], ["base32hex", "v", R(5), "0123456789abcdefghijklmnopqrstuv"], ["base32hexupper", "V", R(5), "0123456789ABCDEFGHIJKLMNOPQRSTUV"], ["base32hexpad", "t", R(5), "0123456789abcdefghijklmnopqrstuv="], ["base32hexpadupper", "T", R(5), "0123456789ABCDEFGHIJKLMNOPQRSTUV="], ["base32", "b", R(5), "abcdefghijklmnopqrstuvwxyz234567"], ["base32upper", "B", R(5), "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"], ["base32pad", "c", R(5), "abcdefghijklmnopqrstuvwxyz234567="], ["base32padupper", "C", R(5), "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567="], ["base32z", "h", R(5), "ybndrfg8ejkmcpqxot1uwisza345h769"], ["base36", "k", S, "0123456789abcdefghijklmnopqrstuvwxyz"], ["base36upper", "K", S, "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"], ["base58btc", "z", S, "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"], ["base58flickr", "Z", S, "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"], ["base64", "m", R(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"], ["base64pad", "M", R(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="], ["base64url", "u", R(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"], ["base64urlpad", "U", R(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_="]],
  L = _.reduce(function (e, n) {
    return e[n[0]] = new P(n[0], n[1], n[2], n[3]), e;
  }, {}),
  q = _.reduce(function (e, n) {
    return e[n[1]] = L[n[0]], e;
  }, {});
var H = {
  names: L,
  codes: q
};
var J = H.names,
  G = $.TextDecoder,
  K = new G("utf8");
var Z = function Z(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "utf8";
  if ("utf8" === n || "utf-8" === n) return K.decode(e);
  if ("ascii" === n) return function (e) {
    var n = "";
    for (var _t = 0; _t < e.length; _t++) n += String.fromCharCode(e[_t]);
    return n;
  }(e);
  var t = J[n];
  if (!t) throw new Error("Unknown base");
  return t.encode(e);
};
var Q = x.v4,
  X = x.v6,
  W = function W(e, n, t) {
    var r;
    if (t = ~~t, Q(e)) r = n || new Uint8Array(t + 4), e.split(/\./g).map(function (e) {
      r[t++] = 255 & parseInt(e, 10);
    });else if (X(e)) {
      var i,
        s = e.split(":", 8);
      for (i = 0; i < s.length; i++) {
        var o;
        Q(s[i]) && (o = W(s[i]), s[i] = Z(o.slice(0, 2), "base16")), o && ++i < 8 && s.splice(i, 0, Z(o.slice(2, 4), "base16"));
      }
      if ("" === s[0]) for (; s.length < 8;) s.unshift("0");else if ("" === s[s.length - 1]) for (; s.length < 8;) s.push("0");else if (s.length < 8) {
        for (i = 0; i < s.length && "" !== s[i]; i++);
        var a = [i, "1"];
        for (i = 9 - s.length; i > 0; i--) a.push("0");
        s.splice.apply(s, a);
      }
      for (r = n || new Uint8Array(t + 16), i = 0; i < s.length; i++) {
        var c = parseInt(s[i], 16);
        r[t++] = c >> 8 & 255, r[t++] = 255 & c;
      }
    }
    if (!r) throw Error("Invalid ip address: " + e);
    return r;
  };
var Y = {
  isIP: x,
  isV4: Q,
  isV6: X,
  toBytes: W,
  toString: function toString(e, n, t) {
    n = ~~n, t = t || e.length - n;
    var r,
      i = [];
    var s = new DataView(e.buffer);
    if (4 === t) {
      for (var _r2 = 0; _r2 < t; _r2++) i.push(e[n + _r2]);
      r = i.join(".");
    } else if (16 === t) {
      for (var _e3 = 0; _e3 < t; _e3 += 2) i.push(s.getUint16(n + _e3).toString(16));
      r = (r = (r = i.join(":")).replace(/(^|:)0(:0)*:0(:|$)/, "$1::$3")).replace(/:{3,4}/, "::");
    }
    return r;
  }
};
function ee(e) {
  if ("number" == typeof e) {
    if (ee.codes[e]) return ee.codes[e];
    throw new Error("no protocol with code: " + e);
  }
  if ("string" == typeof e || e instanceof String) {
    if (ee.names[e]) return ee.names[e];
    throw new Error("no protocol with name: " + e);
  }
  throw new Error("invalid protocol id type: " + e);
}
var ne = -1;
function te(e, n, t, r, i) {
  return {
    code: e,
    size: n,
    name: t,
    resolvable: Boolean(r),
    path: Boolean(i)
  };
}
ee.lengthPrefixedVarSize = ne, ee.V = ne, ee.table = [[4, 32, "ip4"], [6, 16, "tcp"], [33, 16, "dccp"], [41, 128, "ip6"], [42, ne, "ip6zone"], [53, ne, "dns", "resolvable"], [54, ne, "dns4", "resolvable"], [55, ne, "dns6", "resolvable"], [56, ne, "dnsaddr", "resolvable"], [132, 16, "sctp"], [273, 16, "udp"], [275, 0, "p2p-webrtc-star"], [276, 0, "p2p-webrtc-direct"], [277, 0, "p2p-stardust"], [290, 0, "p2p-circuit"], [301, 0, "udt"], [302, 0, "utp"], [400, ne, "unix", !1, "path"], [421, ne, "ipfs"], [421, ne, "p2p"], [443, 0, "https"], [444, 96, "onion"], [445, 296, "onion3"], [446, ne, "garlic64"], [460, 0, "quic"], [477, 0, "ws"], [478, 0, "wss"], [479, 0, "p2p-websocket-star"], [480, 0, "http"], [777, ne, "memory"]], ee.names = {}, ee.codes = {}, ee.table.map(function (e) {
  var n = te.apply(null, e);
  ee.codes[n.code] = n, ee.names[n.name] = n;
}), ee.object = te;
var re = ee,
  ie = j(function (e, n) {
    var t = N.encodeText,
      r = N.decodeText,
      i = N.concat;
    function s(e) {
      if (H.names[e]) return H.names[e];
      if (H.codes[e]) return H.codes[e];
      throw new Error("Unsupported encoding: ".concat(e));
    }
    (n = e.exports = function (e, n) {
      if (!n) throw new Error("requires an encoded Uint8Array");
      var _s = s(e),
        t = _s.name,
        o = _s.codeBuf;
      return function (e, n) {
        s(e).decode(r(n));
      }(t, n), i([o, n], o.length + n.length);
    }).encode = function (e, n) {
      var r = s(e),
        o = t(r.encode(n));
      return i([r.codeBuf, o], r.codeBuf.length + o.length);
    }, n.decode = function (e) {
      e instanceof Uint8Array && (e = r(e));
      var n = e[0];
      return ["f", "F", "v", "V", "t", "T", "b", "B", "c", "C", "h", "k", "K"].includes(n) && (e = e.toLowerCase()), s(e[0]).decode(e.substring(1));
    }, n.isEncoded = function (e) {
      if (e instanceof Uint8Array && (e = r(e)), "[object String]" !== Object.prototype.toString.call(e)) return !1;
      try {
        return s(e[0]).name;
      } catch (e) {
        return !1;
      }
    }, n.encoding = s, n.encodingFromData = function (e) {
      return e instanceof Uint8Array && (e = r(e)), s(e[0]);
    }, n.names = Object.freeze(H.names), n.codes = Object.freeze(H.codes);
  });
var se = {
  names: Object.freeze({
    identity: 0,
    sha1: 17,
    "sha2-256": 18,
    "sha2-512": 19,
    "sha3-512": 20,
    "sha3-384": 21,
    "sha3-256": 22,
    "sha3-224": 23,
    "shake-128": 24,
    "shake-256": 25,
    "keccak-224": 26,
    "keccak-256": 27,
    "keccak-384": 28,
    "keccak-512": 29,
    blake3: 30,
    "murmur3-128": 34,
    "murmur3-32": 35,
    "dbl-sha2-256": 86,
    md4: 212,
    md5: 213,
    bmt: 214,
    "sha2-256-trunc254-padded": 4114,
    "ripemd-128": 4178,
    "ripemd-160": 4179,
    "ripemd-256": 4180,
    "ripemd-320": 4181,
    x11: 4352,
    kangarootwelve: 7425,
    "sm3-256": 21325,
    "blake2b-8": 45569,
    "blake2b-16": 45570,
    "blake2b-24": 45571,
    "blake2b-32": 45572,
    "blake2b-40": 45573,
    "blake2b-48": 45574,
    "blake2b-56": 45575,
    "blake2b-64": 45576,
    "blake2b-72": 45577,
    "blake2b-80": 45578,
    "blake2b-88": 45579,
    "blake2b-96": 45580,
    "blake2b-104": 45581,
    "blake2b-112": 45582,
    "blake2b-120": 45583,
    "blake2b-128": 45584,
    "blake2b-136": 45585,
    "blake2b-144": 45586,
    "blake2b-152": 45587,
    "blake2b-160": 45588,
    "blake2b-168": 45589,
    "blake2b-176": 45590,
    "blake2b-184": 45591,
    "blake2b-192": 45592,
    "blake2b-200": 45593,
    "blake2b-208": 45594,
    "blake2b-216": 45595,
    "blake2b-224": 45596,
    "blake2b-232": 45597,
    "blake2b-240": 45598,
    "blake2b-248": 45599,
    "blake2b-256": 45600,
    "blake2b-264": 45601,
    "blake2b-272": 45602,
    "blake2b-280": 45603,
    "blake2b-288": 45604,
    "blake2b-296": 45605,
    "blake2b-304": 45606,
    "blake2b-312": 45607,
    "blake2b-320": 45608,
    "blake2b-328": 45609,
    "blake2b-336": 45610,
    "blake2b-344": 45611,
    "blake2b-352": 45612,
    "blake2b-360": 45613,
    "blake2b-368": 45614,
    "blake2b-376": 45615,
    "blake2b-384": 45616,
    "blake2b-392": 45617,
    "blake2b-400": 45618,
    "blake2b-408": 45619,
    "blake2b-416": 45620,
    "blake2b-424": 45621,
    "blake2b-432": 45622,
    "blake2b-440": 45623,
    "blake2b-448": 45624,
    "blake2b-456": 45625,
    "blake2b-464": 45626,
    "blake2b-472": 45627,
    "blake2b-480": 45628,
    "blake2b-488": 45629,
    "blake2b-496": 45630,
    "blake2b-504": 45631,
    "blake2b-512": 45632,
    "blake2s-8": 45633,
    "blake2s-16": 45634,
    "blake2s-24": 45635,
    "blake2s-32": 45636,
    "blake2s-40": 45637,
    "blake2s-48": 45638,
    "blake2s-56": 45639,
    "blake2s-64": 45640,
    "blake2s-72": 45641,
    "blake2s-80": 45642,
    "blake2s-88": 45643,
    "blake2s-96": 45644,
    "blake2s-104": 45645,
    "blake2s-112": 45646,
    "blake2s-120": 45647,
    "blake2s-128": 45648,
    "blake2s-136": 45649,
    "blake2s-144": 45650,
    "blake2s-152": 45651,
    "blake2s-160": 45652,
    "blake2s-168": 45653,
    "blake2s-176": 45654,
    "blake2s-184": 45655,
    "blake2s-192": 45656,
    "blake2s-200": 45657,
    "blake2s-208": 45658,
    "blake2s-216": 45659,
    "blake2s-224": 45660,
    "blake2s-232": 45661,
    "blake2s-240": 45662,
    "blake2s-248": 45663,
    "blake2s-256": 45664,
    "skein256-8": 45825,
    "skein256-16": 45826,
    "skein256-24": 45827,
    "skein256-32": 45828,
    "skein256-40": 45829,
    "skein256-48": 45830,
    "skein256-56": 45831,
    "skein256-64": 45832,
    "skein256-72": 45833,
    "skein256-80": 45834,
    "skein256-88": 45835,
    "skein256-96": 45836,
    "skein256-104": 45837,
    "skein256-112": 45838,
    "skein256-120": 45839,
    "skein256-128": 45840,
    "skein256-136": 45841,
    "skein256-144": 45842,
    "skein256-152": 45843,
    "skein256-160": 45844,
    "skein256-168": 45845,
    "skein256-176": 45846,
    "skein256-184": 45847,
    "skein256-192": 45848,
    "skein256-200": 45849,
    "skein256-208": 45850,
    "skein256-216": 45851,
    "skein256-224": 45852,
    "skein256-232": 45853,
    "skein256-240": 45854,
    "skein256-248": 45855,
    "skein256-256": 45856,
    "skein512-8": 45857,
    "skein512-16": 45858,
    "skein512-24": 45859,
    "skein512-32": 45860,
    "skein512-40": 45861,
    "skein512-48": 45862,
    "skein512-56": 45863,
    "skein512-64": 45864,
    "skein512-72": 45865,
    "skein512-80": 45866,
    "skein512-88": 45867,
    "skein512-96": 45868,
    "skein512-104": 45869,
    "skein512-112": 45870,
    "skein512-120": 45871,
    "skein512-128": 45872,
    "skein512-136": 45873,
    "skein512-144": 45874,
    "skein512-152": 45875,
    "skein512-160": 45876,
    "skein512-168": 45877,
    "skein512-176": 45878,
    "skein512-184": 45879,
    "skein512-192": 45880,
    "skein512-200": 45881,
    "skein512-208": 45882,
    "skein512-216": 45883,
    "skein512-224": 45884,
    "skein512-232": 45885,
    "skein512-240": 45886,
    "skein512-248": 45887,
    "skein512-256": 45888,
    "skein512-264": 45889,
    "skein512-272": 45890,
    "skein512-280": 45891,
    "skein512-288": 45892,
    "skein512-296": 45893,
    "skein512-304": 45894,
    "skein512-312": 45895,
    "skein512-320": 45896,
    "skein512-328": 45897,
    "skein512-336": 45898,
    "skein512-344": 45899,
    "skein512-352": 45900,
    "skein512-360": 45901,
    "skein512-368": 45902,
    "skein512-376": 45903,
    "skein512-384": 45904,
    "skein512-392": 45905,
    "skein512-400": 45906,
    "skein512-408": 45907,
    "skein512-416": 45908,
    "skein512-424": 45909,
    "skein512-432": 45910,
    "skein512-440": 45911,
    "skein512-448": 45912,
    "skein512-456": 45913,
    "skein512-464": 45914,
    "skein512-472": 45915,
    "skein512-480": 45916,
    "skein512-488": 45917,
    "skein512-496": 45918,
    "skein512-504": 45919,
    "skein512-512": 45920,
    "skein1024-8": 45921,
    "skein1024-16": 45922,
    "skein1024-24": 45923,
    "skein1024-32": 45924,
    "skein1024-40": 45925,
    "skein1024-48": 45926,
    "skein1024-56": 45927,
    "skein1024-64": 45928,
    "skein1024-72": 45929,
    "skein1024-80": 45930,
    "skein1024-88": 45931,
    "skein1024-96": 45932,
    "skein1024-104": 45933,
    "skein1024-112": 45934,
    "skein1024-120": 45935,
    "skein1024-128": 45936,
    "skein1024-136": 45937,
    "skein1024-144": 45938,
    "skein1024-152": 45939,
    "skein1024-160": 45940,
    "skein1024-168": 45941,
    "skein1024-176": 45942,
    "skein1024-184": 45943,
    "skein1024-192": 45944,
    "skein1024-200": 45945,
    "skein1024-208": 45946,
    "skein1024-216": 45947,
    "skein1024-224": 45948,
    "skein1024-232": 45949,
    "skein1024-240": 45950,
    "skein1024-248": 45951,
    "skein1024-256": 45952,
    "skein1024-264": 45953,
    "skein1024-272": 45954,
    "skein1024-280": 45955,
    "skein1024-288": 45956,
    "skein1024-296": 45957,
    "skein1024-304": 45958,
    "skein1024-312": 45959,
    "skein1024-320": 45960,
    "skein1024-328": 45961,
    "skein1024-336": 45962,
    "skein1024-344": 45963,
    "skein1024-352": 45964,
    "skein1024-360": 45965,
    "skein1024-368": 45966,
    "skein1024-376": 45967,
    "skein1024-384": 45968,
    "skein1024-392": 45969,
    "skein1024-400": 45970,
    "skein1024-408": 45971,
    "skein1024-416": 45972,
    "skein1024-424": 45973,
    "skein1024-432": 45974,
    "skein1024-440": 45975,
    "skein1024-448": 45976,
    "skein1024-456": 45977,
    "skein1024-464": 45978,
    "skein1024-472": 45979,
    "skein1024-480": 45980,
    "skein1024-488": 45981,
    "skein1024-496": 45982,
    "skein1024-504": 45983,
    "skein1024-512": 45984,
    "skein1024-520": 45985,
    "skein1024-528": 45986,
    "skein1024-536": 45987,
    "skein1024-544": 45988,
    "skein1024-552": 45989,
    "skein1024-560": 45990,
    "skein1024-568": 45991,
    "skein1024-576": 45992,
    "skein1024-584": 45993,
    "skein1024-592": 45994,
    "skein1024-600": 45995,
    "skein1024-608": 45996,
    "skein1024-616": 45997,
    "skein1024-624": 45998,
    "skein1024-632": 45999,
    "skein1024-640": 46e3,
    "skein1024-648": 46001,
    "skein1024-656": 46002,
    "skein1024-664": 46003,
    "skein1024-672": 46004,
    "skein1024-680": 46005,
    "skein1024-688": 46006,
    "skein1024-696": 46007,
    "skein1024-704": 46008,
    "skein1024-712": 46009,
    "skein1024-720": 46010,
    "skein1024-728": 46011,
    "skein1024-736": 46012,
    "skein1024-744": 46013,
    "skein1024-752": 46014,
    "skein1024-760": 46015,
    "skein1024-768": 46016,
    "skein1024-776": 46017,
    "skein1024-784": 46018,
    "skein1024-792": 46019,
    "skein1024-800": 46020,
    "skein1024-808": 46021,
    "skein1024-816": 46022,
    "skein1024-824": 46023,
    "skein1024-832": 46024,
    "skein1024-840": 46025,
    "skein1024-848": 46026,
    "skein1024-856": 46027,
    "skein1024-864": 46028,
    "skein1024-872": 46029,
    "skein1024-880": 46030,
    "skein1024-888": 46031,
    "skein1024-896": 46032,
    "skein1024-904": 46033,
    "skein1024-912": 46034,
    "skein1024-920": 46035,
    "skein1024-928": 46036,
    "skein1024-936": 46037,
    "skein1024-944": 46038,
    "skein1024-952": 46039,
    "skein1024-960": 46040,
    "skein1024-968": 46041,
    "skein1024-976": 46042,
    "skein1024-984": 46043,
    "skein1024-992": 46044,
    "skein1024-1000": 46045,
    "skein1024-1008": 46046,
    "skein1024-1016": 46047,
    "skein1024-1024": 46048,
    "poseidon-bls12_381-a2-fc1": 46081,
    "poseidon-bls12_381-a2-fc1-sc": 46082
  })
};
var oe = H.names,
  ae = $.TextEncoder,
  ce = new ae();
var le = function le(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "utf8";
  if ("utf8" === n || "utf-8" === n) return ce.encode(e);
  if ("ascii" === n) return function (e) {
    var n = new Uint8Array(e.length);
    for (var _t2 = 0; _t2 < e.length; _t2++) n[_t2] = e.charCodeAt(_t2);
    return n;
  }(e);
  var t = oe[n];
  if (!t) throw new Error("Unknown base");
  return t.decode(e);
};
var ue = function ue(e, n) {
  n || (n = e.reduce(function (e, n) {
    return e + n.length;
  }, 0));
  var t = new Uint8Array(n);
  var r = 0;
  var _iterator3 = _createForOfIteratorHelper(e),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _n4 = _step3.value;
      t.set(_n4, r), r += _n4.length;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return t;
};
var ke = se.names,
  fe = {};
for (var _e4 in ke) fe[ke[_e4]] = _e4;
function be(e) {
  if (!(e instanceof Uint8Array)) throw new Error("multihash must be a Uint8Array");
  if (e.length < 2) throw new Error("multihash too short. must be > 2 bytes.");
  var n = b.decode(e);
  if (!he(n)) throw new Error("multihash unknown function code: 0x".concat(n.toString(16)));
  e = e.slice(b.decode.bytes);
  var t = b.decode(e);
  if (t < 0) throw new Error("multihash invalid length: ".concat(t));
  if ((e = e.slice(b.decode.bytes)).length !== t) throw new Error("multihash length inconsistent: 0x".concat(Z(e, "base16")));
  return {
    code: n,
    name: fe[n],
    length: t,
    digest: e
  };
}
function de(e) {
  var n = e;
  if ("string" == typeof e) {
    if (void 0 === ke[e]) throw new Error("Unrecognized hash function named: ".concat(e));
    n = ke[e];
  }
  if ("number" != typeof n) throw new Error("Hash function code should be a number. Got: ".concat(n));
  if (void 0 === fe[n] && !pe(n)) throw new Error("Unrecognized function code: ".concat(n));
  return n;
}
function pe(e) {
  return e > 0 && e < 16;
}
function he(e) {
  return !!pe(e) || !!fe[e];
}
function ge(e) {
  be(e);
}
var ye = {
  names: ke,
  codes: Object.freeze(fe),
  toHexString: function toHexString(e) {
    if (!(e instanceof Uint8Array)) throw new Error("must be passed a Uint8Array");
    return Z(e, "base16");
  },
  fromHexString: function fromHexString(e) {
    return le(e, "base16");
  },
  toB58String: function toB58String(e) {
    if (!(e instanceof Uint8Array)) throw new Error("must be passed a Uint8Array");
    return Z(ie.encode("base58btc", e)).slice(1);
  },
  fromB58String: function fromB58String(e) {
    var n = e instanceof Uint8Array ? Z(e) : e;
    return ie.decode("z" + n);
  },
  decode: be,
  encode: function encode(e, n, t) {
    if (!e || void 0 === n) throw new Error("multihash encode requires at least two args: digest, code");
    var r = de(n);
    if (!(e instanceof Uint8Array)) throw new Error("digest should be a Uint8Array");
    if (null == t && (t = e.length), t && e.length !== t) throw new Error("digest length should be equal to specified length.");
    var i = b.encode(r),
      s = b.encode(t);
    return ue([i, s, e], i.length + s.length + e.length);
  },
  coerceCode: de,
  isAppCode: pe,
  validate: ge,
  prefix: function prefix(e) {
    return ge(e), e.subarray(0, 2);
  },
  isValidCode: he
};
var me = {
  baseTable: Object.freeze({
    identity: 0,
    cidv1: 1,
    cidv2: 2,
    cidv3: 3,
    ip4: 4,
    tcp: 6,
    sha1: 17,
    "sha2-256": 18,
    "sha2-512": 19,
    "sha3-512": 20,
    "sha3-384": 21,
    "sha3-256": 22,
    "sha3-224": 23,
    "shake-128": 24,
    "shake-256": 25,
    "keccak-224": 26,
    "keccak-256": 27,
    "keccak-384": 28,
    "keccak-512": 29,
    blake3: 30,
    dccp: 33,
    "murmur3-128": 34,
    "murmur3-32": 35,
    ip6: 41,
    ip6zone: 42,
    path: 47,
    multicodec: 48,
    multihash: 49,
    multiaddr: 50,
    multibase: 51,
    dns: 53,
    dns4: 54,
    dns6: 55,
    dnsaddr: 56,
    protobuf: 80,
    cbor: 81,
    raw: 85,
    "dbl-sha2-256": 86,
    rlp: 96,
    bencode: 99,
    "dag-pb": 112,
    "dag-cbor": 113,
    "libp2p-key": 114,
    "git-raw": 120,
    "torrent-info": 123,
    "torrent-file": 124,
    "leofcoin-block": 129,
    "leofcoin-tx": 130,
    "leofcoin-pr": 131,
    sctp: 132,
    "dag-jose": 133,
    "dag-cose": 134,
    "eth-block": 144,
    "eth-block-list": 145,
    "eth-tx-trie": 146,
    "eth-tx": 147,
    "eth-tx-receipt-trie": 148,
    "eth-tx-receipt": 149,
    "eth-state-trie": 150,
    "eth-account-snapshot": 151,
    "eth-storage-trie": 152,
    "bitcoin-block": 176,
    "bitcoin-tx": 177,
    "bitcoin-witness-commitment": 178,
    "zcash-block": 192,
    "zcash-tx": 193,
    docid: 206,
    "stellar-block": 208,
    "stellar-tx": 209,
    md4: 212,
    md5: 213,
    bmt: 214,
    "decred-block": 224,
    "decred-tx": 225,
    "ipld-ns": 226,
    "ipfs-ns": 227,
    "swarm-ns": 228,
    "ipns-ns": 229,
    zeronet: 230,
    "secp256k1-pub": 231,
    "bls12_381-g1-pub": 234,
    "bls12_381-g2-pub": 235,
    "x25519-pub": 236,
    "ed25519-pub": 237,
    "bls12_381-g1g2-pub": 238,
    "dash-block": 240,
    "dash-tx": 241,
    "swarm-manifest": 250,
    "swarm-feed": 251,
    udp: 273,
    "p2p-webrtc-star": 275,
    "p2p-webrtc-direct": 276,
    "p2p-stardust": 277,
    "p2p-circuit": 290,
    "dag-json": 297,
    udt: 301,
    utp: 302,
    unix: 400,
    p2p: 421,
    ipfs: 421,
    https: 443,
    onion: 444,
    onion3: 445,
    garlic64: 446,
    garlic32: 447,
    tls: 448,
    quic: 460,
    ws: 477,
    wss: 478,
    "p2p-websocket-star": 479,
    http: 480,
    json: 512,
    messagepack: 513,
    "libp2p-peer-record": 769,
    "sha2-256-trunc254-padded": 4114,
    "ripemd-128": 4178,
    "ripemd-160": 4179,
    "ripemd-256": 4180,
    "ripemd-320": 4181,
    x11: 4352,
    "p256-pub": 4608,
    "p384-pub": 4609,
    "p521-pub": 4610,
    "ed448-pub": 4611,
    "x448-pub": 4612,
    "ed25519-priv": 4864,
    kangarootwelve: 7425,
    "sm3-256": 21325,
    "blake2b-8": 45569,
    "blake2b-16": 45570,
    "blake2b-24": 45571,
    "blake2b-32": 45572,
    "blake2b-40": 45573,
    "blake2b-48": 45574,
    "blake2b-56": 45575,
    "blake2b-64": 45576,
    "blake2b-72": 45577,
    "blake2b-80": 45578,
    "blake2b-88": 45579,
    "blake2b-96": 45580,
    "blake2b-104": 45581,
    "blake2b-112": 45582,
    "blake2b-120": 45583,
    "blake2b-128": 45584,
    "blake2b-136": 45585,
    "blake2b-144": 45586,
    "blake2b-152": 45587,
    "blake2b-160": 45588,
    "blake2b-168": 45589,
    "blake2b-176": 45590,
    "blake2b-184": 45591,
    "blake2b-192": 45592,
    "blake2b-200": 45593,
    "blake2b-208": 45594,
    "blake2b-216": 45595,
    "blake2b-224": 45596,
    "blake2b-232": 45597,
    "blake2b-240": 45598,
    "blake2b-248": 45599,
    "blake2b-256": 45600,
    "blake2b-264": 45601,
    "blake2b-272": 45602,
    "blake2b-280": 45603,
    "blake2b-288": 45604,
    "blake2b-296": 45605,
    "blake2b-304": 45606,
    "blake2b-312": 45607,
    "blake2b-320": 45608,
    "blake2b-328": 45609,
    "blake2b-336": 45610,
    "blake2b-344": 45611,
    "blake2b-352": 45612,
    "blake2b-360": 45613,
    "blake2b-368": 45614,
    "blake2b-376": 45615,
    "blake2b-384": 45616,
    "blake2b-392": 45617,
    "blake2b-400": 45618,
    "blake2b-408": 45619,
    "blake2b-416": 45620,
    "blake2b-424": 45621,
    "blake2b-432": 45622,
    "blake2b-440": 45623,
    "blake2b-448": 45624,
    "blake2b-456": 45625,
    "blake2b-464": 45626,
    "blake2b-472": 45627,
    "blake2b-480": 45628,
    "blake2b-488": 45629,
    "blake2b-496": 45630,
    "blake2b-504": 45631,
    "blake2b-512": 45632,
    "blake2s-8": 45633,
    "blake2s-16": 45634,
    "blake2s-24": 45635,
    "blake2s-32": 45636,
    "blake2s-40": 45637,
    "blake2s-48": 45638,
    "blake2s-56": 45639,
    "blake2s-64": 45640,
    "blake2s-72": 45641,
    "blake2s-80": 45642,
    "blake2s-88": 45643,
    "blake2s-96": 45644,
    "blake2s-104": 45645,
    "blake2s-112": 45646,
    "blake2s-120": 45647,
    "blake2s-128": 45648,
    "blake2s-136": 45649,
    "blake2s-144": 45650,
    "blake2s-152": 45651,
    "blake2s-160": 45652,
    "blake2s-168": 45653,
    "blake2s-176": 45654,
    "blake2s-184": 45655,
    "blake2s-192": 45656,
    "blake2s-200": 45657,
    "blake2s-208": 45658,
    "blake2s-216": 45659,
    "blake2s-224": 45660,
    "blake2s-232": 45661,
    "blake2s-240": 45662,
    "blake2s-248": 45663,
    "blake2s-256": 45664,
    "skein256-8": 45825,
    "skein256-16": 45826,
    "skein256-24": 45827,
    "skein256-32": 45828,
    "skein256-40": 45829,
    "skein256-48": 45830,
    "skein256-56": 45831,
    "skein256-64": 45832,
    "skein256-72": 45833,
    "skein256-80": 45834,
    "skein256-88": 45835,
    "skein256-96": 45836,
    "skein256-104": 45837,
    "skein256-112": 45838,
    "skein256-120": 45839,
    "skein256-128": 45840,
    "skein256-136": 45841,
    "skein256-144": 45842,
    "skein256-152": 45843,
    "skein256-160": 45844,
    "skein256-168": 45845,
    "skein256-176": 45846,
    "skein256-184": 45847,
    "skein256-192": 45848,
    "skein256-200": 45849,
    "skein256-208": 45850,
    "skein256-216": 45851,
    "skein256-224": 45852,
    "skein256-232": 45853,
    "skein256-240": 45854,
    "skein256-248": 45855,
    "skein256-256": 45856,
    "skein512-8": 45857,
    "skein512-16": 45858,
    "skein512-24": 45859,
    "skein512-32": 45860,
    "skein512-40": 45861,
    "skein512-48": 45862,
    "skein512-56": 45863,
    "skein512-64": 45864,
    "skein512-72": 45865,
    "skein512-80": 45866,
    "skein512-88": 45867,
    "skein512-96": 45868,
    "skein512-104": 45869,
    "skein512-112": 45870,
    "skein512-120": 45871,
    "skein512-128": 45872,
    "skein512-136": 45873,
    "skein512-144": 45874,
    "skein512-152": 45875,
    "skein512-160": 45876,
    "skein512-168": 45877,
    "skein512-176": 45878,
    "skein512-184": 45879,
    "skein512-192": 45880,
    "skein512-200": 45881,
    "skein512-208": 45882,
    "skein512-216": 45883,
    "skein512-224": 45884,
    "skein512-232": 45885,
    "skein512-240": 45886,
    "skein512-248": 45887,
    "skein512-256": 45888,
    "skein512-264": 45889,
    "skein512-272": 45890,
    "skein512-280": 45891,
    "skein512-288": 45892,
    "skein512-296": 45893,
    "skein512-304": 45894,
    "skein512-312": 45895,
    "skein512-320": 45896,
    "skein512-328": 45897,
    "skein512-336": 45898,
    "skein512-344": 45899,
    "skein512-352": 45900,
    "skein512-360": 45901,
    "skein512-368": 45902,
    "skein512-376": 45903,
    "skein512-384": 45904,
    "skein512-392": 45905,
    "skein512-400": 45906,
    "skein512-408": 45907,
    "skein512-416": 45908,
    "skein512-424": 45909,
    "skein512-432": 45910,
    "skein512-440": 45911,
    "skein512-448": 45912,
    "skein512-456": 45913,
    "skein512-464": 45914,
    "skein512-472": 45915,
    "skein512-480": 45916,
    "skein512-488": 45917,
    "skein512-496": 45918,
    "skein512-504": 45919,
    "skein512-512": 45920,
    "skein1024-8": 45921,
    "skein1024-16": 45922,
    "skein1024-24": 45923,
    "skein1024-32": 45924,
    "skein1024-40": 45925,
    "skein1024-48": 45926,
    "skein1024-56": 45927,
    "skein1024-64": 45928,
    "skein1024-72": 45929,
    "skein1024-80": 45930,
    "skein1024-88": 45931,
    "skein1024-96": 45932,
    "skein1024-104": 45933,
    "skein1024-112": 45934,
    "skein1024-120": 45935,
    "skein1024-128": 45936,
    "skein1024-136": 45937,
    "skein1024-144": 45938,
    "skein1024-152": 45939,
    "skein1024-160": 45940,
    "skein1024-168": 45941,
    "skein1024-176": 45942,
    "skein1024-184": 45943,
    "skein1024-192": 45944,
    "skein1024-200": 45945,
    "skein1024-208": 45946,
    "skein1024-216": 45947,
    "skein1024-224": 45948,
    "skein1024-232": 45949,
    "skein1024-240": 45950,
    "skein1024-248": 45951,
    "skein1024-256": 45952,
    "skein1024-264": 45953,
    "skein1024-272": 45954,
    "skein1024-280": 45955,
    "skein1024-288": 45956,
    "skein1024-296": 45957,
    "skein1024-304": 45958,
    "skein1024-312": 45959,
    "skein1024-320": 45960,
    "skein1024-328": 45961,
    "skein1024-336": 45962,
    "skein1024-344": 45963,
    "skein1024-352": 45964,
    "skein1024-360": 45965,
    "skein1024-368": 45966,
    "skein1024-376": 45967,
    "skein1024-384": 45968,
    "skein1024-392": 45969,
    "skein1024-400": 45970,
    "skein1024-408": 45971,
    "skein1024-416": 45972,
    "skein1024-424": 45973,
    "skein1024-432": 45974,
    "skein1024-440": 45975,
    "skein1024-448": 45976,
    "skein1024-456": 45977,
    "skein1024-464": 45978,
    "skein1024-472": 45979,
    "skein1024-480": 45980,
    "skein1024-488": 45981,
    "skein1024-496": 45982,
    "skein1024-504": 45983,
    "skein1024-512": 45984,
    "skein1024-520": 45985,
    "skein1024-528": 45986,
    "skein1024-536": 45987,
    "skein1024-544": 45988,
    "skein1024-552": 45989,
    "skein1024-560": 45990,
    "skein1024-568": 45991,
    "skein1024-576": 45992,
    "skein1024-584": 45993,
    "skein1024-592": 45994,
    "skein1024-600": 45995,
    "skein1024-608": 45996,
    "skein1024-616": 45997,
    "skein1024-624": 45998,
    "skein1024-632": 45999,
    "skein1024-640": 46e3,
    "skein1024-648": 46001,
    "skein1024-656": 46002,
    "skein1024-664": 46003,
    "skein1024-672": 46004,
    "skein1024-680": 46005,
    "skein1024-688": 46006,
    "skein1024-696": 46007,
    "skein1024-704": 46008,
    "skein1024-712": 46009,
    "skein1024-720": 46010,
    "skein1024-728": 46011,
    "skein1024-736": 46012,
    "skein1024-744": 46013,
    "skein1024-752": 46014,
    "skein1024-760": 46015,
    "skein1024-768": 46016,
    "skein1024-776": 46017,
    "skein1024-784": 46018,
    "skein1024-792": 46019,
    "skein1024-800": 46020,
    "skein1024-808": 46021,
    "skein1024-816": 46022,
    "skein1024-824": 46023,
    "skein1024-832": 46024,
    "skein1024-840": 46025,
    "skein1024-848": 46026,
    "skein1024-856": 46027,
    "skein1024-864": 46028,
    "skein1024-872": 46029,
    "skein1024-880": 46030,
    "skein1024-888": 46031,
    "skein1024-896": 46032,
    "skein1024-904": 46033,
    "skein1024-912": 46034,
    "skein1024-920": 46035,
    "skein1024-928": 46036,
    "skein1024-936": 46037,
    "skein1024-944": 46038,
    "skein1024-952": 46039,
    "skein1024-960": 46040,
    "skein1024-968": 46041,
    "skein1024-976": 46042,
    "skein1024-984": 46043,
    "skein1024-992": 46044,
    "skein1024-1000": 46045,
    "skein1024-1008": 46046,
    "skein1024-1016": 46047,
    "skein1024-1024": 46048,
    "poseidon-bls12_381-a2-fc1": 46081,
    "poseidon-bls12_381-a2-fc1-sc": 46082,
    "zeroxcert-imprint-256": 52753,
    "fil-commitment-unsealed": 61697,
    "fil-commitment-sealed": 61698,
    "holochain-adr-v0": 8417572,
    "holochain-adr-v1": 8483108,
    "holochain-key-v0": 9728292,
    "holochain-key-v1": 9793828,
    "holochain-sig-v0": 10645796,
    "holochain-sig-v1": 10711332,
    "skynet-ns": 11639056
  })
};
var we = me.baseTable,
  ve = new Map();
for (var _e5 in we) {
  var _n5 = we[_e5];
  ve.set(_n5, _e5);
}
var Ee = Object.freeze(ve),
  Ae = {
    numberToUint8Array: function numberToUint8Array(e) {
      var n = e.toString(16);
      n.length % 2 == 1 && (n = "0" + n);
      return le(n, "base16");
    },
    uint8ArrayToNumber: xe,
    varintUint8ArrayEncode: function varintUint8ArrayEncode(e) {
      return Uint8Array.from(b.encode(xe(e)));
    },
    varintEncode: function varintEncode(e) {
      return Uint8Array.from(b.encode(e));
    }
  };
function xe(e) {
  return parseInt(Z(e, "base16"), 16);
}
var Se = me.baseTable,
  je = Ae.varintEncode,
  Te = {};
for (var _e6 in Se) {
  var _n6 = Se[_e6];
  Te[_e6] = je(_n6);
}
var Oe = Object.freeze(Te);
var Ue = me.baseTable,
  $e = {};
for (var _i2 = 0, _Object$entries = Object.entries(Ue); _i2 < _Object$entries.length; _i2++) {
  var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
    _e7 = _Object$entries$_i[0],
    _n7 = _Object$entries$_i[1];
  $e[_e7.toUpperCase().replace(/-/g, "_")] = _n7;
}
var Ce = Object.freeze($e);
var ze = me.baseTable,
  Ie = {};
for (var _i3 = 0, _Object$entries2 = Object.entries(ze); _i3 < _Object$entries2.length; _i3++) {
  var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2),
    _e8 = _Object$entries2$_i[0],
    _n8 = _Object$entries2$_i[1];
  void 0 === Ie[_n8] && (Ie[_n8] = _e8);
}
var De = _objectSpread({
  addPrefix: function addPrefix(e, n) {
    var t;
    if (e instanceof Uint8Array) t = Ae.varintUint8ArrayEncode(e);else {
      if (!Oe[e]) throw new Error("multicodec not recognized");
      t = Oe[e];
    }
    return ue([t, n], t.length + n.length);
  },
  rmPrefix: function rmPrefix(e) {
    return b.decode(e), e.slice(b.decode.bytes);
  },
  getCodec: function getCodec(e) {
    var n = b.decode(e),
      t = Ee.get(n);
    if (void 0 === t) throw new Error("Code ".concat(n, " not found"));
    return t;
  },
  getName: function getName(e) {
    return Ee.get(e);
  },
  getNumber: function getNumber(e) {
    var n = Oe[e];
    if (void 0 === n) throw new Error("Codec `" + e + "` not found");
    return b.decode(n);
  },
  getCode: function getCode(e) {
    return b.decode(e);
  },
  getCodeVarint: function getCodeVarint(e) {
    var n = Oe[e];
    if (void 0 === n) throw new Error("Codec `" + e + "` not found");
    return n;
  },
  getVarint: function getVarint(e) {
    return b.encode(e);
  },
  print: Object.freeze(Ie)
}, Ce);
var Ne = {
  checkCIDComponents: function checkCIDComponents(e) {
    if (null == e) return "null values are not valid CIDs";
    if (0 !== e.version && 1 !== e.version) return "Invalid version, must be a number equal to 1 or 0";
    if ("string" != typeof e.codec) return "codec must be string";
    if (0 === e.version) {
      if ("dag-pb" !== e.codec) return "codec must be 'dag-pb' for CIDv0";
      if ("base58btc" !== e.multibaseName) return "multibaseName must be 'base58btc' for CIDv0";
    }
    if (!(e.multihash instanceof Uint8Array)) return "multihash must be a Uint8Array";
    try {
      ye.validate(e.multihash);
    } catch (e) {
      var _n9 = e.message;
      return _n9 || (_n9 = "Multihash validation failed"), _n9;
    }
  }
};
var Me = function Me(e, n) {
  if (e === n) return !0;
  if (e.byteLength !== n.byteLength) return !1;
  for (var _t3 = 0; _t3 < e.byteLength; _t3++) if (e[_t3] !== n[_t3]) return !1;
  return !0;
};
var Pe = me.baseTable,
  Be = Object.keys(Pe).reduce(function (e, n) {
    return e[Pe[n]] = n, e;
  }, {}),
  Re = Symbol.for("@ipld/js-cid/CID");
var Ve = /*#__PURE__*/function (_Symbol$for) {
  function Ve(e, n, t, r) {
    _classCallCheck(this, Ve);
    if (Object.defineProperty(this, Re, {
      value: !0
    }), Ve.isCID(e)) {
      var _n10 = e;
      return this.version = _n10.version, this.codec = _n10.codec, this.multihash = _n10.multihash, void (this.multibaseName = _n10.multibaseName || (0 === _n10.version ? "base58btc" : "base32"));
    }
    if ("string" == typeof e) {
      var _n11 = ie.isEncoded(e);
      if (_n11) {
        var _t4 = ie.decode(e);
        this.version = parseInt(_t4[0].toString(), 16), this.codec = De.getCodec(_t4.slice(1)), this.multihash = De.rmPrefix(_t4.slice(1)), this.multibaseName = _n11;
      } else this.version = 0, this.codec = "dag-pb", this.multihash = ye.fromB58String(e), this.multibaseName = "base58btc";
      return Ve.validateCID(this), void Object.defineProperty(this, "string", {
        value: e
      });
    }
    if (e instanceof Uint8Array) {
      var _n12 = parseInt(e[0].toString(), 16);
      if (1 === _n12) {
        var _t5 = e;
        this.version = _n12, this.codec = De.getCodec(_t5.slice(1)), this.multihash = De.rmPrefix(_t5.slice(1)), this.multibaseName = "base32";
      } else this.version = 0, this.codec = "dag-pb", this.multihash = e, this.multibaseName = "base58btc";
      Ve.validateCID(this);
    } else this.version = e, "number" == typeof n && (n = Be[n]), this.codec = n, this.multihash = t, this.multibaseName = r || (0 === e ? "base58btc" : "base32"), Ve.validateCID(this);
  }
  _createClass(Ve, [{
    key: "bytes",
    get: function get() {
      var e = this._bytes;
      if (!e) {
        if (0 === this.version) e = this.multihash;else {
          if (1 !== this.version) throw new Error("unsupported version");
          {
            var _n13 = De.getCodeVarint(this.codec);
            e = ue([[1], _n13, this.multihash], 1 + _n13.byteLength + this.multihash.byteLength);
          }
        }
        Object.defineProperty(this, "_bytes", {
          value: e
        });
      }
      return e;
    }
  }, {
    key: "prefix",
    get: function get() {
      var e = De.getCodeVarint(this.codec),
        n = ye.prefix(this.multihash);
      return ue([[this.version], e, n], 1 + e.byteLength + n.byteLength);
    }
  }, {
    key: "code",
    get: function get() {
      return Pe[this.codec];
    }
  }, {
    key: "toV0",
    value: function toV0() {
      if ("dag-pb" !== this.codec) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
      var _ye$decode = ye.decode(this.multihash),
        e = _ye$decode.name,
        n = _ye$decode.length;
      if ("sha2-256" !== e) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
      if (32 !== n) throw new Error("Cannot convert non 32 byte multihash CID to CIDv0");
      return new Ve(0, this.codec, this.multihash);
    }
  }, {
    key: "toV1",
    value: function toV1() {
      return new Ve(1, this.codec, this.multihash);
    }
  }, {
    key: "toBaseEncodedString",
    value: function toBaseEncodedString() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.multibaseName;
      if (this.string && 0 !== this.string.length && e === this.multibaseName) return this.string;
      var n;
      if (0 === this.version) {
        if ("base58btc" !== e) throw new Error("not supported with CIDv0, to support different bases, please migrate the instance do CIDv1, you can do that through cid.toV1()");
        n = ye.toB58String(this.multihash);
      } else {
        if (1 !== this.version) throw new Error("unsupported version");
        n = Z(ie.encode(e, this.bytes));
      }
      return e === this.multibaseName && Object.defineProperty(this, "string", {
        value: n
      }), n;
    }
  }, {
    key: _Symbol$for,
    value: function value() {
      return "CID(" + this.toString() + ")";
    }
  }, {
    key: "toString",
    value: function toString(e) {
      return this.toBaseEncodedString(e);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        codec: this.codec,
        version: this.version,
        hash: this.multihash
      };
    }
  }, {
    key: "equals",
    value: function equals(e) {
      return this.codec === e.codec && this.version === e.version && Me(this.multihash, e.multihash);
    }
  }], [{
    key: "validateCID",
    value: function validateCID(e) {
      var n = Ne.checkCIDComponents(e);
      if (n) throw new Error(n);
    }
  }, {
    key: "isCID",
    value: function isCID(e) {
      return e instanceof Ve || Boolean(e && e[Re]);
    }
  }]);
  return Ve;
}(Symbol.for("nodejs.util.inspect.custom"));
Ve.codecs = Pe;
var Fe = Ve,
  _e = function e(n, t, r) {
    t = t || [];
    var i = r = r || 0;
    for (; n >= Le;) t[r++] = 255 & n | 128, n /= 128;
    for (; -128 & n;) t[r++] = 255 & n | 128, n >>>= 7;
    return t[r] = 0 | n, e.bytes = r - i + 1, t;
  },
  Le = Math.pow(2, 31);
var qe = function e(n, t) {
  var r,
    i = 0,
    s = 0,
    o = t = t || 0,
    a = n.length;
  do {
    if (o >= a) throw e.bytes = 0, new RangeError("Could not decode varint");
    r = n[o++], i += s < 28 ? (127 & r) << s : (127 & r) * Math.pow(2, s), s += 7;
  } while (r >= 128);
  return e.bytes = o - t, i;
};
var He = Math.pow(2, 7),
  Je = Math.pow(2, 14),
  Ge = Math.pow(2, 21),
  Ke = Math.pow(2, 28),
  Ze = Math.pow(2, 35),
  Qe = Math.pow(2, 42),
  Xe = Math.pow(2, 49),
  We = Math.pow(2, 56),
  Ye = Math.pow(2, 63),
  en = {
    encode: _e,
    decode: qe,
    encodingLength: function encodingLength(e) {
      return e < He ? 1 : e < Je ? 2 : e < Ge ? 3 : e < Ke ? 4 : e < Ze ? 5 : e < Qe ? 6 : e < Xe ? 7 : e < We ? 8 : e < Ye ? 9 : 10;
    }
  },
  nn = tn;
function tn(e, n) {
  return n instanceof Uint8Array ? tn.toString(e, n) : tn.toBytes(e, n);
}
function rn(e) {
  if (!Y.isIP(e)) throw new Error("invalid ip address");
  return Y.toBytes(e);
}
function sn(e) {
  var n = new ArrayBuffer(2);
  return new DataView(n).setUint16(0, e), new Uint8Array(n);
}
function on(e) {
  return new DataView(e.buffer).getUint16(0);
}
function an(e) {
  var n = e.slice(0, e.length - 2),
    t = e.slice(e.length - 2);
  return Z(n, "base32") + ":" + on(t);
}
tn.toString = function (e, n) {
  switch ((e = re(e)).code) {
    case 4:
    case 41:
      return function (e) {
        var n = Y.toString(e);
        if (!n || !Y.isIP(n)) throw new Error("invalid ip address");
        return n;
      }(n);
    case 6:
    case 273:
    case 33:
    case 132:
      return on(n);
    case 53:
    case 54:
    case 55:
    case 56:
    case 400:
    case 777:
      return function (e) {
        var n = en.decode(e);
        if ((e = e.slice(en.decode.bytes)).length !== n) throw new Error("inconsistent lengths");
        return Z(e);
      }(n);
    case 421:
      return function (e) {
        var n = en.decode(e),
          t = e.slice(en.decode.bytes);
        if (t.length !== n) throw new Error("inconsistent lengths");
        return Z(t, "base58btc");
      }(n);
    case 444:
    case 445:
      return an(n);
    default:
      return Z(n, "base16");
  }
}, tn.toBytes = function (e, n) {
  switch ((e = re(e)).code) {
    case 4:
    case 41:
      return rn(n);
    case 6:
    case 273:
    case 33:
    case 132:
      return sn(parseInt(n, 10));
    case 53:
    case 54:
    case 55:
    case 56:
    case 400:
    case 777:
      return function (e) {
        var n = le(e),
          t = Uint8Array.from(en.encode(n.length));
        return ue([t, n], t.length + n.length);
      }(n);
    case 421:
      return function (e) {
        var n = new Fe(e).multihash,
          t = Uint8Array.from(en.encode(n.length));
        return ue([t, n], t.length + n.length);
      }(n);
    case 444:
      return function (e) {
        var n = e.split(":");
        if (2 !== n.length) throw new Error("failed to parse onion addr: " + n + " does not contain a port number");
        if (16 !== n[0].length) throw new Error("failed to parse onion addr: " + n[0] + " not a Tor onion address.");
        var t = ie.decode("b" + n[0]),
          r = parseInt(n[1], 10);
        if (r < 1 || r > 65536) throw new Error("Port number is not in range(1, 65536)");
        var i = sn(r);
        return ue([t, i], t.length + i.length);
      }(n);
    case 445:
      return function (e) {
        var n = e.split(":");
        if (2 !== n.length) throw new Error("failed to parse onion addr: " + n + " does not contain a port number");
        if (56 !== n[0].length) throw new Error("failed to parse onion addr: " + n[0] + " not a Tor onion3 address.");
        var t = ie.decode("b" + n[0]),
          r = parseInt(n[1], 10);
        if (r < 1 || r > 65536) throw new Error("Port number is not in range(1, 65536)");
        var i = sn(r);
        return ue([t, i], t.length + i.length);
      }(n);
    default:
      return le(n, "base16");
  }
};
var cn = {
  stringToStringTuples: ln,
  stringTuplesToString: un,
  tuplesToStringTuples: fn,
  stringTuplesToTuples: kn,
  bytesToTuples: pn,
  tuplesToBytes: bn,
  bytesToString: function bytesToString(e) {
    var n = pn(e);
    return un(fn(n));
  },
  stringToBytes: hn,
  fromString: function fromString(e) {
    return hn(e);
  },
  fromBytes: gn,
  validateBytes: yn,
  isValidBytes: function isValidBytes(e) {
    return void 0 === yn(e);
  },
  cleanPath: mn,
  ParseError: wn,
  protoFromTuple: vn,
  sizeForAddr: dn
};
function ln(e) {
  var n = [],
    t = e.split("/").slice(1);
  if (1 === t.length && "" === t[0]) return [];
  for (var _r3 = 0; _r3 < t.length; _r3++) {
    var _i4 = t[_r3],
      _s2 = re(_i4);
    if (0 !== _s2.size) {
      if (_r3++, _r3 >= t.length) throw wn("invalid address: " + e);
      if (_s2.path) {
        n.push([_i4, mn(t.slice(_r3).join("/"))]);
        break;
      }
      n.push([_i4, t[_r3]]);
    } else n.push([_i4]);
  }
  return n;
}
function un(e) {
  var n = [];
  return e.map(function (e) {
    var t = vn(e);
    n.push(t.name), e.length > 1 && n.push(e[1]);
  }), mn(n.join("/"));
}
function kn(e) {
  return e.map(function (e) {
    Array.isArray(e) || (e = [e]);
    var n = vn(e);
    return e.length > 1 ? [n.code, nn.toBytes(n.code, e[1])] : [n.code];
  });
}
function fn(e) {
  return e.map(function (e) {
    var n = vn(e);
    return e.length > 1 ? [n.code, nn.toString(n.code, e[1])] : [n.code];
  });
}
function bn(e) {
  return gn(ue(e.map(function (e) {
    var n = vn(e);
    var t = Uint8Array.from(en.encode(n.code));
    return e.length > 1 && (t = ue([t, e[1]])), t;
  })));
}
function dn(e, n) {
  if (e.size > 0) return e.size / 8;
  if (0 === e.size) return 0;
  return en.decode(n) + en.decode.bytes;
}
function pn(e) {
  var n = [];
  var t = 0;
  for (; t < e.length;) {
    var _r4 = en.decode(e, t),
      _i5 = en.decode.bytes,
      _s3 = dn(re(_r4), e.slice(t + _i5));
    if (0 === _s3) {
      n.push([_r4]), t += _i5;
      continue;
    }
    var _o = e.slice(t + _i5, t + _i5 + _s3);
    if (t += _s3 + _i5, t > e.length) throw wn("Invalid address Uint8Array: " + Z(e, "base16"));
    n.push([_r4, _o]);
  }
  return n;
}
function hn(e) {
  return bn(kn(ln(e = mn(e))));
}
function gn(e) {
  var n = yn(e);
  if (n) throw n;
  return Uint8Array.from(e);
}
function yn(e) {
  try {
    pn(e);
  } catch (e) {
    return e;
  }
}
function mn(e) {
  return "/" + e.trim().split("/").filter(function (e) {
    return e;
  }).join("/");
}
function wn(e) {
  return new Error("Error parsing address: " + e);
}
function vn(e) {
  return re(e[0]);
}
var En = function En(e, _ref) {
    var n = _ref.className,
      t = _ref.symbolName;
    var r = Symbol.for(t),
      i = _defineProperty({}, n, /*#__PURE__*/function (_e9, _Symbol$toStringTag) {
        _inherits(_class, _e9);
        var _super = _createSuper(_class);
        function _class() {
          var _this;
          _classCallCheck(this, _class);
          for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
            e[_key] = arguments[_key];
          }
          _this = _super.call.apply(_super, [this].concat(e)), Object.defineProperty(_assertThisInitialized(_this), r, {
            value: !0
          });
          return _this;
        }
        _createClass(_class, [{
          key: _Symbol$toStringTag,
          get: function get() {
            return n;
          }
        }]);
        return _class;
      }(e, Symbol.toStringTag))[n];
    return i["is".concat(n)] = function (e) {
      return !(!e || !e[r]);
    }, i;
  },
  An = function An(e, _ref2) {
    var n = _ref2.className,
      t = _ref2.symbolName,
      r = _ref2.withoutNew;
    var i = Symbol.for(t),
      s = _defineProperty({}, n, function () {
        for (var _len2 = arguments.length, n = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          n[_key2] = arguments[_key2];
        }
        if (r && !(this instanceof s)) return _construct(s, n);
        var t = e.call.apply(e, [this].concat(n)) || this;
        return t && !t[i] && Object.defineProperty(t, i, {
          value: !0
        }), t;
      })[n];
    return s.prototype = Object.create(e.prototype), s.prototype.constructor = s, Object.defineProperty(s.prototype, Symbol.toStringTag, {
      get: function get() {
        return n;
      }
    }), s["is".concat(n)] = function (e) {
      return !(!e || !e[i]);
    }, s;
  };
function xn(e, n) {
  for (var _t6 in n) Object.defineProperty(e, _t6, {
    value: n[_t6],
    enumerable: !0,
    configurable: !0
  });
  return e;
}
En.proto = An;
var Sn = function Sn(e, n, t) {
    if (!e || "string" == typeof e) throw new TypeError("Please pass an Error to err-code");
    t || (t = {}), "object" == typeof n && (t = n, n = void 0), null != n && (t.code = n);
    try {
      return xn(e, t);
    } catch (n) {
      t.message = e.message, t.stack = e.stack;
      var _r5 = function _r5() {};
      return _r5.prototype = Object.create(Object.getPrototypeOf(e)), xn(new _r5(), t);
    }
  },
  jn = j(function (e, n) {
    var t = Symbol.for("nodejs.util.inspect.custom"),
      r = new Map(),
      i = En.proto(function (e) {
        if (!(this instanceof i)) return new i(e);
        if (null == e && (e = ""), e instanceof Uint8Array) this.bytes = cn.fromBytes(e);else if ("string" == typeof e || e instanceof String) {
          if (e.length > 0 && "/" !== e.charAt(0)) throw new Error("multiaddr \"".concat(e, "\" must start with a \"/\""));
          this.bytes = cn.fromString(e);
        } else {
          if (!(e.bytes && e.protos && e.protoCodes)) throw new Error("addr must be a string, Buffer, or another Multiaddr");
          this.bytes = cn.fromBytes(e.bytes);
        }
      }, {
        className: "Multiaddr",
        symbolName: "@multiformats/js-multiaddr/multiaddr"
      });
    i.prototype.toString = function () {
      return cn.bytesToString(this.bytes);
    }, i.prototype.toJSON = i.prototype.toString, i.prototype.toOptions = function () {
      var e = {},
        n = this.toString().split("/");
      return e.family = "ip4" === n[1] ? "ipv4" : "ipv6", e.host = n[2], e.transport = n[3], e.port = parseInt(n[4]), e;
    }, i.prototype[t] = function () {
      return "<Multiaddr " + Z(this.bytes, "base16") + " - " + cn.bytesToString(this.bytes) + ">";
    }, i.prototype.inspect = function () {
      return "<Multiaddr " + Z(this.bytes, "base16") + " - " + cn.bytesToString(this.bytes) + ">";
    }, i.prototype.protos = function () {
      return this.protoCodes().map(function (e) {
        return Object.assign({}, re(e));
      });
    }, i.prototype.protoCodes = function () {
      var e = [],
        n = this.bytes;
      var t = 0;
      for (; t < n.length;) {
        var _r6 = en.decode(n, t),
          _i6 = en.decode.bytes,
          _s4 = re(_r6);
        t += cn.sizeForAddr(_s4, n.slice(t + _i6)) + _i6, e.push(_r6);
      }
      return e;
    }, i.prototype.protoNames = function () {
      return this.protos().map(function (e) {
        return e.name;
      });
    }, i.prototype.tuples = function () {
      return cn.bytesToTuples(this.bytes);
    }, i.prototype.stringTuples = function () {
      var e = cn.bytesToTuples(this.bytes);
      return cn.tuplesToStringTuples(e);
    }, i.prototype.encapsulate = function (e) {
      return e = i(e), i(this.toString() + e.toString());
    }, i.prototype.decapsulate = function (e) {
      e = e.toString();
      var n = this.toString(),
        t = n.lastIndexOf(e);
      if (t < 0) throw new Error("Address " + this + " does not contain subaddress: " + e);
      return i(n.slice(0, t));
    }, i.prototype.decapsulateCode = function (e) {
      var n = this.tuples();
      for (var _t7 = n.length - 1; _t7 >= 0; _t7--) if (n[_t7][0] === e) return i(cn.tuplesToBytes(n.slice(0, _t7)));
      return this;
    }, i.prototype.getPeerId = function () {
      var e = null;
      try {
        e = this.stringTuples().filter(function (e) {
          if (e[0] === re.names.ipfs.code) return !0;
        }).pop()[1], e = Z(new Fe(e).multihash, "base58btc");
      } catch (n) {
        e = null;
      }
      return e;
    }, i.prototype.getPath = function () {
      var e = null;
      try {
        e = this.stringTuples().filter(function (e) {
          if (re(e[0]).path) return !0;
        })[0][1];
      } catch (n) {
        e = null;
      }
      return e;
    }, i.prototype.equals = function (e) {
      return Me(this.bytes, e.bytes);
    }, i.prototype.resolve = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var e, n;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e = this.protos().find(function (e) {
              return e.resolvable;
            });
            if (e) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", [this]);
          case 3:
            n = r.get(e.name);
            if (n) {
              _context.next = 6;
              break;
            }
            throw Sn(new Error("no available resolver for ".concat(e.name)), "ERR_NO_AVAILABLE_RESOLVER");
          case 6:
            _context.next = 8;
            return n(this);
          case 8:
            return _context.abrupt("return", _context.sent.map(function (e) {
              return i(e);
            }));
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    })), i.prototype.nodeAddress = function () {
      var e = this.protoCodes(),
        n = this.protoNames(),
        t = this.toString().split("/").slice(1);
      if (t.length < 4) throw new Error('multiaddr must have a valid format: "/{ip4, ip6, dns4, dns6}/{address}/{tcp, udp}/{port}".');
      if (4 !== e[0] && 41 !== e[0] && 54 !== e[0] && 55 !== e[0]) throw new Error("no protocol with name: \"'".concat(n[0], "'\". Must have a valid family name: \"{ip4, ip6, dns4, dns6}\"."));
      if ("tcp" !== t[2] && "udp" !== t[2]) throw new Error("no protocol with name: \"'".concat(n[1], "'\". Must have a valid transport protocol: \"{tcp, udp}\"."));
      return {
        family: 41 === e[0] || 55 === e[0] ? 6 : 4,
        address: t[1],
        port: parseInt(t[3])
      };
    }, i.fromNodeAddress = function (e, n) {
      if (!e) throw new Error("requires node address object");
      if (!n) throw new Error("requires transport protocol");
      var t;
      switch (e.family) {
        case "IPv4":
          t = "ip4";
          break;
        case "IPv6":
          t = "ip6";
          break;
        default:
          throw Error("Invalid addr family. Got '".concat(e.family, "' instead of 'IPv4' or 'IPv6'"));
      }
      return i("/" + [t, e.address, n, e.port].join("/"));
    }, i.prototype.isThinWaistAddress = function (e) {
      var n = (e || this).protos();
      return 2 === n.length && (4 === n[0].code || 41 === n[0].code) && (6 === n[1].code || 273 === n[1].code);
    }, i.protocols = re, i.isName = function (e) {
      return !!i.isMultiaddr(e) && e.protos().some(function (e) {
        return e.resolvable;
      });
    }, i.resolve = function (e) {
      return i.isMultiaddr(e) && i.isName(e) ? Promise.reject(new Error("not implemented yet")) : Promise.reject(Error("not a valid name"));
    }, i.resolvers = r, e.exports = i;
  });
function Tn(n, t) {
  switch (jn.protocols(n).code) {
    case 406:
      return function (n) {
        var t = b.decode(n);
        if ((n = n.slice(b.decode.bytes)).length !== t) throw new Error("inconsistent lengths");
        return e.fromBytes(n).toString();
      }(t);
    default:
      return nn.toString(n, t);
  }
}
function On(n, t) {
  switch (jn.protocols(n).code) {
    case 406:
      return function (n) {
        var t = e.fromString(n).toBytes(),
          r = b.encode(t.length);
        return Uint8Array.from([].concat(_toConsumableArray(r), _toConsumableArray(t)));
      }(t);
    default:
      return nn.toBytes(n, t);
  }
}
function Un(e) {
  return e.map(function (e) {
    var n = Pn(e);
    return e.length > 1 ? [n.code, Tn(n.code, e[1])] : [n.code];
  });
}
function $n(e, n) {
  if (e.size > 0) return e.size / 8;
  if (0 === e.size) return 0;
  return b.decode(n) + b.decode.bytes;
}
function Cn(e) {
  var n = [];
  var t = 0;
  for (; t < e.length;) {
    var _r7 = b.decode(e, t),
      _i7 = b.decode.bytes,
      _s5 = $n(jn.protocols(_r7), e.slice(t + _i7));
    if (0 === _s5) {
      n.push([_r7]), t += _i7;
      continue;
    }
    var _o2 = e.slice(t + _i7, t + _i7 + _s5);
    if (t += _s5 + _i7, t > e.length) throw Mn("Invalid address Uint8Array");
    n.push([_r7, _o2]);
  }
  return n;
}
function zn(e) {
  return function (e) {
    var n = [];
    return e.map(function (e) {
      var t = Pn(e);
      n.push(t.name), e.length > 1 && n.push(e[1]);
    }), Nn(n.join("/"));
  }(Un(Cn(e)));
}
function In(e) {
  var n = function (e) {
    var n = [],
      t = e.split("/").slice(1);
    if (1 === t.length && "" === t[0]) return [];
    for (var _r8 = 0; _r8 < t.length; _r8++) {
      var _i8 = t[_r8],
        _s6 = jn.protocols(_i8);
      if (0 !== _s6.size) {
        if (_r8++, _r8 >= t.length) throw Mn("invalid address: " + e);
        if (_s6.path) {
          n.push([_i8, Nn(t.slice(_r8).join("/"))]);
          break;
        }
        n.push([_i8, t[_r8]]);
      } else n.push([_i8]);
    }
    return n;
  }(e = Nn(e));
  return function (e) {
    return Dn(new Uint8Array(e.flatMap(function (e) {
      var n = Pn(e);
      var t = Uint8Array.from(b.encode(n.code));
      return e.length > 1 && (t = new Uint8Array([].concat(_toConsumableArray(t), _toConsumableArray(e[1])))), _toConsumableArray(t);
    })));
  }(n.map(function (e) {
    Array.isArray(e) || (e = [e]);
    var n = Pn(e);
    return e.length > 1 ? [n.code, On(n.code, e[1])] : [n.code];
  }));
}
function Dn(e) {
  var n = function (e) {
    try {
      Cn(e);
    } catch (e) {
      return e;
    }
  }(e);
  if (n) throw n;
  return Uint8Array.from(e);
}
function Nn(e) {
  return "/" + e.trim().split("/").filter(function (e) {
    return e;
  }).join("/");
}
function Mn(e) {
  return new Error("Error parsing address: " + e);
}
function Pn(e) {
  return jn.protocols(e[0]);
}
function Bn(e) {
  null == e && (e = "");
  var n = new Uint8Array(0);
  if (e instanceof Uint8Array) n = Dn(e);else if ("string" == typeof e) {
    if (e.length > 0 && "/" !== e.charAt(0)) throw new Error("multiaddr \"".concat(e, "\" must start with a \"/\""));
    n = In(e);
  } else {
    if (!(e.bytes && e.protos && e.protoCodes)) throw new Error("addr must be a string, Uint8Array, or another Multiaddr");
    n = Dn(e.bytes);
  }
  return n;
}
function Rn(e) {
  return zn(e);
}
function Vn(e) {
  return Un(Cn(e));
}
function Fn(e) {
  var n = Rn(e).split("/");
  return {
    family: "ip4" === n[1] ? "ipv4" : "ipv6",
    host: n[2],
    transport: n[3],
    port: parseInt(n[4])
  };
}
jn.protocols.codes[406] = {
  code: 406,
  size: -1,
  name: "thread",
  resolvable: !1,
  path: !1
}, jn.protocols.names.thread = {
  code: 406,
  size: -1,
  name: "thread",
  resolvable: !1,
  path: !1
}, jn.protocols.table.push([406, -1, "thead"]);
export { Bn as bytesFromAddr, Fn as bytesToOptions, Vn as bytesToTuples, Rn as stringFromBytes };